<template>
  <div class="border-b border-gray-300 py-5 grid gap-5">
    <div class="flex flex-row gap-4 justify-between">
      <span class="font-sans font-medium text-lg flex-grow">{{ name }}</span>
      <button class="" @click="emit('remove')">
        <CommonFontAwesomeIcon
          icon="fa-regular fa-close"
          class="w-4 h-4 text-black opacity-50 hover:opacity-100 hover:cursor-pointer"
        />
      </button>
    </div>
    <div class="flex flex-row justify-between items-end">
      <div class="grid gap-1">
        <span
          v-if="discount > 0"
          class="text-red font-sans text-sm font-medium"
          >{{
            $t('saveAmountPercentage', {
              amount: Math.round(discount * 100),
            })
          }}</span
        >
        <span
          v-if="discount > 0"
          class="text-sm text-gray-600 line-through leading-none"
          >{{ $formatCurrency(Math.ceil(amountPerYear / 12)) }}</span
        >
        <span class="font-sans font-medium text-lg"
          >{{ $formatCurrency(Math.ceil((amountPerYear / 12) * (1 - discount)))
          }}<span class="text-sm"> {{ $t('perMonth') }}</span></span
        >
        <span class="text-sm text-gray-600 font-medium font-sans"
          >{{ $t('YearlyPayment') }}
          {{
            $formatCurrency(Math.round(amountPerYear * (1 - discount)))
          }}</span
        >
      </div>
      <span class="font-sans text-blue text-sm">{{
        $t('14DayFreeTrial')
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    name: string
    amountPerYear: number
    discount?: number
  }>(),
  {
    discount: 0,
  }
)

const emit = defineEmits<{
  (e: 'remove'): void
}>()
</script>
